import React, { useState, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import './indexinnumbers.css';
import bgnumbers from '../images/bgnumberswhite.webp';
import ArrowRight from './ArrowRights.js';

const Counter = ({ end }) => {
  const [count, setCount] = useState(0);
  const { ref, inView } = useInView({
    threshold: 0.1, // Se activa cuando el 10% del elemento es visible
  });

  useEffect(() => {
    let start = 0;
    let counter;

    if (inView) {
      const duration = 2000;
      const increment = end / (duration / 10);

      counter = setInterval(() => {
        start += increment;
        if (start >= end) {
          clearInterval(counter);
          setCount(end);
        } else {
          setCount(Math.ceil(start));
        }
      }, 10);
    } else {
      setCount(0); // Resetea el contador cuando ya no esté visible
    }

    return () => clearInterval(counter); // Limpia el intervalo cuando el componente se desmonta o cambia de vista

  }, [inView, end]);

  return (
    <div ref={ref}>
      {count}
    </div>
  );
};

const IndexInNumbers = () => {
  return (
    <section className='indexinnumbers' style={{ backgroundImage: `url(${bgnumbers})` }}>
      <div className='line'><img src='../images/line.webp' title='line' alt='title'></img></div>
      <div className='content'>
        <p className='subtitles'>IN NUMBERS</p>
        <div className='titles'>
            <h2 className='indexTitle'>INDEX<i>®</i><sub>-</sub></h2>
            <ArrowRight className="custom-arrow" />
            <span className='bajada'>Nuestra vida a lo largo de nuestros <strong>17 años</strong></span>
        </div>
        <ol>
          <li><span>+</span><h4><Counter end={1000} /></h4><p>ecommerce</p></li>
          <li><span>+</span><h4><Counter end={2000} /></h4><p>websites</p></li>
          <li><h4><Counter end={17} /></h4><p>años</p></li>
          <li><span>+</span><h4><Counter end={200} /></h4><p>clientes</p></li>
          <li><span>+</span><h4><Counter end={30} /></h4><p>especialistas</p></li>
        </ol>
      </div>
    </section>
  );
};

export default IndexInNumbers;